import { useEffect } from 'react';
import { connect } from 'getstream';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import queryFnDirect from '../../queries/streamQueryDirect';
import useUser from '@/hooks/useUser';
import {
  queryFn as mutationQueryFn,
  QUERY_KEY as DASHBOARD_FEED_QUERY_KEY,
} from '@components/Dashboard/hooks/useFeed';
import { GETSTREAM_API_KEY, GETSTREAM_APP_ID } from '@/constants/env';
export enum Status {
  OFF,
  ON,
  ERROR,
}

export const useStream = () => {
  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: mutationQueryFn,
    mutationKey: ['USE-FEED'],
    retry: false,
  });
  const user = useUser();
  const { data, status: streamStatus } = useQuery({
    queryKey: ['STREAM_TOKEN'],
    queryFn: queryFnDirect,
    staleTime: Infinity,
    enabled: user.data.loggedIn,
    retry: false,
  });

  useEffect(() => {
    if (typeof data?.token === 'string' && streamStatus === 'success') {
      const stream = connect(GETSTREAM_API_KEY, data.token, GETSTREAM_APP_ID, {
        browser: true,
      });
      const feed = stream.feed('user', user.data.id);
      const subscription = feed.subscribe(() => {
        /**
         * We mutate so that we can call the dashboard feed endpoint with a cache busting var.
         * Then, instead of introducing anothher query key, we can set the existing key's cache data.
         */
        mutate(true, {
          onSuccess: (data) => {
            queryClient.setQueryData([DASHBOARD_FEED_QUERY_KEY], data);
          },
        });
      });
      const fayeClient = feed.getFayeClient();
      return () => {
        feed.unsubscribe();
        (subscription as any).cancel();
        (fayeClient as any).disable();
        (fayeClient as any).disconnect();
        console.log(`Stream Unsubscribe`);
      };
    }
  }, [user.data.id, data, streamStatus, mutate, queryClient]);
};
